import { Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";


export const ProjectCard = ({ title, description, imgUrl,  linkUrl, techstack }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    if (linkUrl) {
      // Open external project link in a new tab
      window.open(linkUrl, "_blank");
    } else {
      // Navigate to the "Coming Soon" page for unfinished projects
      navigate("/coming-soon");
    }
  };

  return (
    <Col xs={12} sm={6} md={6} lg={4}>
      <div
        className="proj-imgbx"
        onClick={handleCardClick}
        style={{ cursor: "pointer" }}
      >
        
          <img
            src={imgUrl}
            alt={title}
            className="rounded-lg w-full h-[100%] object-cover mx-2 my-4"
          />
      

      
        <div className="proj-txtx text-center">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
      </div>

       {techstack.map((tech, index) => (
        <span key={index} className="px-1 text-black text-sm font-medium">
          {tech},
        </span>
      ))}

    </Col>

    
  );
};
